var render = function (_h,_vm) {var _c=_vm._c;return _c('img',{staticClass:"ebx-filter__color-circle",attrs:{"src":("" + (_vm.props.filter.colorUrl))}})}
var staticRenderFns = []

export { render, staticRenderFns }